export default state => ({ ...state, processDescriptionSnapshots: [] })
